import styled from 'styled-components'
import { LogoProps, SvgArrowDotsProps } from './types'
import { ThemeColorsKeysType } from '../Styles/theme'

export const Svg = styled('svg')<LogoProps>`
  width: ${props => props.widthValue};
  height: 65px;
  cursor: pointer;
  path {
    fill: ${props =>
    props.theme.colors.main[props.darkMode ? 'blank' : 'dark']};
  }
`

export const SvgArrowDots = styled('svg')<SvgArrowDotsProps>`
  height: ${props => props?.heightValue};
  path {
    fill: ${props =>
    props.theme.colors.main?.[props?.color as ThemeColorsKeysType]};
  }
`
